"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionEventCommercialLineItemTypeSharedFields = exports.CommercialLineItemTypeSharedUpdateFields = exports.CommercialLineItemTypeSharedCreateFields = exports.CommercialLineItemTypeSharedQuery = exports.CommercialLineItemTypeSharedFields = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const enums_1 = require("../enums");
exports.CommercialLineItemTypeSharedFields = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    name: typebox_1.Type.String(),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    priceUnitType: enums_1.PriceUnitType,
    priceBasisType: enums_1.PriceBasisType,
    unitPrice: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    percentValue: typebox_1.Type.Optional(typebox_1.Type.Number({
        minimum: 0,
        maximum: 10000,
        description: 'in basis points (i.e. percent * 100)',
    })),
    taxable: typebox_1.Type.Boolean(),
    metadata: common_1.MetaData,
});
exports.CommercialLineItemTypeSharedQuery = typebox_1.Type.Object({
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
});
exports.CommercialLineItemTypeSharedCreateFields = typebox_1.Type.Omit(exports.CommercialLineItemTypeSharedFields, [
    'id',
    'haulerID',
    'metadata',
]);
exports.CommercialLineItemTypeSharedUpdateFields = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CommercialLineItemTypeSharedFields, ['id', 'haulerID', 'unitPrice', 'percentValue', 'metadata']),
    typebox_1.Type.Object({
        unitPrice: (0, common_1.Nullable)(typebox_1.Type.Integer()),
        percentValue: (0, common_1.Nullable)(typebox_1.Type.Number({
            minimum: 0,
            maximum: 10000,
            description: 'in basis points (i.e. percent * 100)',
        })),
    }),
]));
exports.SubscriptionEventCommercialLineItemTypeSharedFields = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.CommercialLineItemTypeSharedFields, ['metadata']));
//# sourceMappingURL=commercial-line-item-type-shared.js.map